import { render, staticRenderFns } from "./ModalSimulador.vue?vue&type=template&id=8d530d12&scoped=true"
import script from "./ModalSimulador.vue?vue&type=script&lang=js"
export * from "./ModalSimulador.vue?vue&type=script&lang=js"
import style0 from "./ModalSimulador.vue?vue&type=style&index=0&id=8d530d12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d530d12",
  null
  
)

export default component.exports